import styled from "styled-components"
import media from "styleguide/styles/media-queries"

const Hero = styled.div`
  padding-bottom: 104px;
  ${media.tablet`
    padding-top: 150px;
    padding-bottom: 80px;
  `}
`

export default Hero
